module.exports = __webpack_public_path__ + "img/music-square.a3f0ad27.svg";